import { useState } from "react";
import Navigator from "../../components/Navigator";
import styles from "./MainMobile.module.css";
import Divider from "../components/Divider";
import ProductDetails from "../components/ProductDetails";
import CTAButton from "../../components/CTAButton";
import { Slide } from "react-awesome-reveal";
import Footer from "../../components/Footer";
import ImageCarousel from "../components/ImageCarousel";
import Pricing from "./Pricing";

const productImages = [
    require('../../images/product/1.png'),
    require('../../images/product/2.png'),
    require('../../images/product/3.jpg'),
    require('../../images/product/4.png'),
    require('../../images/product/5.png'),
    require('../../images/product/6.png'),
]
const MainMobile = () => {
    const [showButton, setShowButton] = useState(false);
    const [direction, setDirection] = useState("up");


    function handleScrollToTop(e) {
        e.preventDefault(); // prevent default jump
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function handleHideCTA() {
        if (!showButton) return
        setTimeout(() => setShowButton(false), 100)
        setDirection("down")
    }

    function handleShowCTA() {
        if (showButton) return
        setTimeout(() => setShowButton(true), 100)
        setDirection("up")
    }

    return (
        <div className={styles.screen}>
            <Navigator />

            <main className={styles.main}>
                <div className={styles.container}>
                    <ImageCarousel  images={productImages} />
                    <Pricing
                        onEnter={() => handleHideCTA()}
                        onLeave={() => handleShowCTA()}
                    />
                    <Divider />
                </div>
                
                <ProductDetails onCtaEnter={handleHideCTA} onCtaExit={handleShowCTA} />
                <Slide
                    duration={500}
                    direction={direction}
                    className={styles.sticky_cta_container}
                    style={{ display: showButton ? "flex" : 'none', bottom: direction == "down" ? '-50px' : "0px" }}>
                    <CTAButton
                        className={styles.sticky_cta}
                        titleClass={styles.sticky_cta_title}
                        subtitleClass={styles.sticky_cta_sub}
                        iconClass={styles.cta_icon}
                    />
                </Slide>

            </main>
            <a onClick={handleScrollToTop} href="#" className={styles.arrow_top}>
                <img src={require('../../images/arrow_top.png')} />
            </a>
            <Footer />
        </div>
    );
};

export default MainMobile;
